import { authCall } from '.'
import { ResponseStatus } from '../interfaces/common'
import {
  CreateEstateType,
  EstateDto,
  UpdateEstateType,
  UploadRes,
} from '../interfaces/estate'
import { EditStaff, EstateStaffProfileDTO } from '../interfaces/staff'
import { estates, uploadFiles } from './endpoints'
const EstateService = {
  createStaff: (data: CreateEstateType) => {
    const url = estates
    return authCall<ResponseStatus>({
      url,
      data,
      method: 'post',
    })
  },
  getEstateById: (estateId: string) => {
    const url = `${estates}/${estateId}`
    return authCall<ResponseStatus<EstateDto>>({
      url,
      method: 'get',
    })
  },
  updateEstate: (estateId: string, data: UpdateEstateType) => {
    const url = `estates/${estateId}`
    return authCall<ResponseStatus>({
      url,
      data,
      method: 'patch',
    })
  },

  disableOrEnableStaff: (staffId: string, disableOrEnableAction: string) => {
    const url = `estates/staffs/${staffId}/${disableOrEnableAction}`
    return authCall<ResponseStatus>({
      url,
      data: { disableOrEnableAction },
      method: 'put',
    })
  },

  acceptEstateInviteStaffResident: (estateId: string) => {
    const url = `estates/${estateId}/accept-invite`
    return authCall<EstateStaffProfileDTO>({
      url,
      data: { estateId },
      method: 'put',
    })
  },
  
  getEstateStaffId: (staffMemberId: string) => {
    const url = `estates/staff/${staffMemberId}`
    return authCall<EstateStaffProfileDTO>({
      url,
      data: { staffMemberId },
      method: 'get',
    })
  },

  editEstateStaffId: (staffMemberId: string, data: EditStaff) => {
    const url = `estates/staff/${staffMemberId}`
    return authCall<ResponseStatus>({
      url,
      data,
      method: 'patch',
    })
  },
  uploadPhoto: async (file: File) => {
    const url = uploadFiles
    const formData = new FormData()
    formData.append('file', file)
    return authCall<UploadRes>({
      url,
      data: formData,
      method: 'post',
    }).then((response) => response.data.url)
  },


}

export default EstateService
